import { render, staticRenderFns } from "./optimumProposal.vue?vue&type=template&id=c7493a30&scoped=true"
import script from "./optimumProposal.vue?vue&type=script&lang=js"
export * from "./optimumProposal.vue?vue&type=script&lang=js"
import style0 from "./optimumProposal.vue?vue&type=style&index=0&id=c7493a30&prod&lang=less"
import style1 from "./optimumProposal.vue?vue&type=style&index=1&id=c7493a30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7493a30",
  null
  
)

export default component.exports